const statusConfig = {
  created:         { label: 'Created',         className: 'bg-gray-100 text-gray-700' },
  allocated:       { label: 'Allocated',       className: 'bg-blue-50 text-blue-700' },
  in_progress:     { label: 'In Progress',     className: 'bg-amber-50 text-amber-700' },
  signed:          { label: 'Signed',          className: 'bg-purple-50 text-purple-700' },
  completed:       { label: 'Completed',       className: 'bg-emerald-50 text-emerald-700' },
  email_exception: { label: 'Email Exception', className: 'bg-red-50 text-red-700' },
  archived:        { label: 'Archived',        className: 'bg-gray-100 text-gray-600' },
};

export function StatusBadge({ status }) {
  const config = statusConfig[status] || { label: status, className: 'bg-gray-100 text-gray-700' };

  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-md text-xs font-medium whitespace-nowrap ${config.className}`}
      data-testid={`status-badge-${status}`}
    >
      {config.label}
    </span>
  );
}
